import React from 'react'
import type { MetaDataHighlight, HighlightToken } from '@core/Areas/Search/types'
import { colors } from '@mobi/component-library/Foundations'
import styled from '@emotion/styled'

interface Props {
  displayText: string
  highlights: MetaDataHighlight
  highlightKey: string
}

export const HighlightDisplay: React.FC<Props> = ({ displayText, highlights, highlightKey }) => {
  if (!highlights[highlightKey]) return displayText

  return highlights[highlightKey].map((token: HighlightToken, index: number) => {
    const key = `${token.value}_${index}`
    return token.isMatch ? (
      <HighlightStyled key={key}>
        <span>{token.value}</span>
      </HighlightStyled>
    ) : (
      <span key={key}>{token.value}</span>
    )
  })
}

// ======
// Styles
// ======

const HighlightStyled = styled.span({
  position: 'relative',
  color: colors.studio[600],

  '::before': {
    content: '""',
    position: 'absolute',
    top: '-0.2em',
    bottom: '-0.2em',
    left: '-0.1em',
    right: '-0.1em',
    zIndex: 0,
    backgroundColor: '#F2ECF7',
  },

  '> span': {
    position: 'relative',
    zIndex: 1,
  },
})
